import { Button, Container, FormField, Input, Modal, SpaceBetween } from '@cloudscape-design/components';
import Calendar from "@cloudscape-design/components/calendar";
import { mdiArrowExpandDown, mdiArrowExpandLeft, mdiArrowExpandRight, mdiDeleteOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, format, parse } from 'date-fns';
import React, { useState } from 'react';
import { hideKeyboardGlobally, normalizeDate } from '../pages/commons/functions';
interface DPModalProps {
  close?: boolean;
  clear?: boolean;
  today?: boolean;
  tomorrow?: boolean;
  yesterday?: boolean;
  start?: Date;
  end?: Date;
  date?: string
  title?: string;
  subTitle?: string;
  disabledDates?: string[];
  width?: number;
  //onDismiss: () => void;
  onConfirm: (selectedDate: string) => void;
}
const DPModal: React.FC<DPModalProps> = ({
  close = false,
  clear = true,
  today = false,
  tomorrow = false,
  yesterday = false,
  start = undefined,
  end = undefined,
  width = 200,
  date = "",
  title = 'Seleccione',
  subTitle = '',
  disabledDates = [],
  onConfirm,
}) => {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleDateChange = ({ detail }: { detail: { value: string } }) => {
    setSelectedDate(normalizeDate(detail.value));
    onConfirm(normalizeDate(detail.value));
    date = detail.value
    hideKeyboardGlobally();
    onDismiss();
  };
  const onDismiss = () => {
    setShowModal(false);
  }
  const dateClear = () => {
    setSelectedDate('')
    onConfirm('');
  }
  const mapDateStringsToDates = (dateStrings: string[]): Date[] => {
    return dateStrings.map(item =>
      // The parse function requires the date string, the format, and a reference date
      parse(item, "dd-MM-yyyy", new Date())
    );
  };

  // This is the array (list of Date objects) you will check against:
  const disabledDatesArray: Date[] = mapDateStringsToDates(disabledDates);

  const isSameDay = (date1: Date, date2: Date): boolean => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
  const isDateInDisabledList = (d: Date): boolean => {
    // Use .some() to check if ANY disabledDate in the array matches the input date (d)
    return disabledDatesArray.some(disabledDate => isSameDay(d, disabledDate));
  };
  const dateToday = () => {
    const formatted = format(new Date(), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }
  const dateYesterday = () => {
    const formatted = format(addDays(new Date(), -1), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }
  const dateTomorrow = () => {
    const formatted = format(addDays(new Date(), 1), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }
  const normalizedStart = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : undefined;
  const normalizedEnd = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : undefined;
  //const normalizedDate = end ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : undefined;
  const isDateInRange = (date: Date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (normalizedStart && normalizedEnd) return d >= normalizedStart && d <= normalizedEnd;
    if (normalizedStart) return d >= normalizedStart;
    if (normalizedEnd) return d <= normalizedEnd;
    return true;
  };


  return (
    <>
      <div style={{ maxWidth: width, cursor: 'pointer' }} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true)
      }}>
        <Input value={date} onChange={() => { }} placeholder='Seleccionar fecha'
          inputMode="none"
        />
      </div>
      <Modal
        visible={showModal}
        onDismiss={onDismiss}
        size="small"
        header={title}
        footer={
          <SpaceBetween direction='horizontal' size='xs'>
            {close && (
              <Button variant="link" onClick={onDismiss}>Cerrar</Button>
            )}
            {yesterday && (
              <Button variant="primary" onClick={dateYesterday}><Icon path={mdiArrowExpandLeft} size={1} /></Button>
            )}
            {today && (
              <Button variant="primary" onClick={dateToday}><Icon path={mdiArrowExpandDown} size={1} /></Button>
            )}
            {tomorrow && (
              <Button variant="primary" onClick={dateTomorrow}><Icon path={mdiArrowExpandRight} size={1} /></Button>
            )}
            {clear && (
              <Button variant="primary" onClick={dateClear}><Icon path={mdiDeleteOutline} size={1} /></Button>
            )}
          </SpaceBetween>
        }
      >
        <FormField label={subTitle} stretch>
          <Container>
            <Calendar
              value={normalizeDate(date)}

              onChange={handleDateChange}
              locale="es-CL"
              startOfWeek={1}
              isDateEnabled={(date) => {
                return isDateInRange(date) && !isDateInDisabledList(date)

              }}
            />
          </Container>
        </FormField>
      </Modal >
    </>
  );
};

export default DPModal;